/**! guest/index */

import "../polyfills"
import "@app/main"
